import {connect} from 'react-redux';
import classNames from 'classnames';

import {TypeMap} from 'topmeteo/general/constants';
import {getColumn, getProduct} from 'topmeteo/general/selectors';

import {canPreload} from 'topmeteo/base-image/actionCreators';

import EventListener from 'topmeteo/general/components/EventListener';

import SwitchProduct from '../SwitchProduct';
import SwitchIndex from '../SwitchIndex';
import SwitchDate from '../SwitchDate';
import MapImage from '../MapImage';

import Loading from './Loading';
import BrowseLayer from './BrowseLayer';

import useDelayedLoading from './hooks';

const BrowseLayerOuter = ({type, url, ...props}) => {
    const {isPlayable, isRequesting, isInteractive, startPreload, abortPreload, ...mapImageProps} = props;
    const [loading, onLoad] = useDelayedLoading(url, isRequesting, isInteractive, startPreload, abortPreload);

    return (
        <div className={classNames('zoom', 'browse-layer-outer', {'is-playable': isPlayable})}>
            <EventListener target={window} onBeforeUnload={abortPreload} onUnload={abortPreload} />
            <MapImage {...mapImageProps} url={url} loading={loading} onLoad={onLoad} />
            <BrowseLayer>
                <SwitchProduct />
            </BrowseLayer>
            {type === TypeMap && (
                <BrowseLayer>
                    <SwitchDate />
                </BrowseLayer>
            )}
            <BrowseLayer>
                <SwitchIndex />
            </BrowseLayer>
            {loading && <Loading />}
        </div>
    );
};

const mapStateToProps = state => {
    const {request, isAnimating, isDragging} = state;
    const {available, url} = getColumn(state);
    const {title, isPlayable} = getProduct(state);

    return {
        isRequesting: Boolean(request && request.immediate),
        isInteractive: Boolean(isAnimating || isDragging),
        url: available && url,
        isPlayable,
        title,
    };
};

const mapDispatchToProps = dispatch => ({
    startPreload: () => dispatch(canPreload(true)),
    abortPreload: () => {
        /* do not use implicit returning function
           or IE will show a confirmation pop up */
        dispatch(canPreload(false));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(BrowseLayerOuter);
